<template>

</template>

<script>
    // import
    import { mapGetters } from "vuex";
    import { mapActions } from "vuex";
    
    // export
    export default {

        computed: {

            ...mapGetters({
                getBase: "getBase"
            }),

        }

        , data() {
            return {

                gubun_page: "REGIFORM"

            }
        }

        , methods: {
            
            ...mapActions({
                setBase: "setBase"
            })

            // 진입점
            , init() {

                // 로그아웃
                this.setLogout();

            }

            // 데이터 조회
            , setLogout() {

                var data = this.$GetQueryMap();
                data.gubun_page = this.gubun_page;

                // API 조회
                this.$SendPost("/vue_api/user/login/logout", data, this.getReturnView);

            }

            // 뷰 데이터
            , getReturnView(data, err) {

                // dimm 숨기기
                this.$HideDimmLogo();

            }

        }

        , beforeCreate() {
        }

        , created() {
        }

        , beforeMount() {
        }

        , mounted() {
            this.$AfterMounted(this);
        }

        , beforeUpdate() {
        }

        , updated() {
            this.$AfterUpdated(this);
        }

        , beforeDestroy() {
        }

        , destroyed() {
        }

    }

</script>